export interface IEnvironmentTemplate {
  variant: string;
  baseUrl: string;
}
export const getSubDomain = (envTemplate: IEnvironmentTemplate) => {
  const spliter = `.${envTemplate.baseUrl}`;
  if (window.location.hostname.includes(spliter)) {
    return `${window.location.hostname.split(spliter)[0]}.`;
  } else return '';
};
